import React from 'react';

export default React.createContext({
  clientID: null,
  token: null,
  userLogin : null,
  login: (username,password) => {},
  logout: ()=>{}
})